export default "__VITE_ASSET__960e4ff4__"